<template>
  <div id="app">
    <!-- <keep-alive>
      <component :is="currentView" @changeview="changeview"></component>
    </keep-alive> -->
    <!-- <keep-alive :exclude="['Krpano', 'pano', 'Container', 'container']"> -->
      <router-view></router-view>
    <!-- </keep-alive> -->
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style lang="scss" scoped>
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position:relative;
}
#app > div {
  height: 100%;
  width: 100%;
}
</style>